const STORAGE_KEY = "acertei.campaigns.dismissed";


function storageKey(surface: string): string {
  return `${STORAGE_KEY}:${surface}`;
}

export function readDismissed(surface: string): string[] {
  try {
    const raw = localStorage.getItem(storageKey(surface));
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.filter((x) => typeof x === "string") : [];
  } catch {
    return [];
  }
}

export function writeDismissed(surface: string, ids: string[]): void {
  try {
    localStorage.setItem(storageKey(surface), JSON.stringify(ids));
  } catch {
    return;
  }
}
